<template>
  <tr  class="type">
    <td class="text-left" :data-label="translate('sim_task_list.task_types.code')">
      {{ type.code }}
    </td>
    <td class="text-left" :data-label="translate('sim_task_list.task_types.name')">
      {{ type.name }}
    </td>
    <td class="text-left" :data-label="translate('sim_task_list.task_types.allowed_oper_accounts')">
      <div v-for="(account, index) in type.allowed_oper_accounts" :key="account.id || index">
        {{ account.mno_label }} {{ account.oper_account }}
      </div>
    </td>
    <td :data-label="translate('sim_task_list.task_types.handler')">
      {{ type.handler }}
    </td>
    <td :data-label="translate('sim_task_list.task_types.target_result')">
      {{ type.target_result }}
    </td>
    <td :data-label="translate('sim_task_list.task_types.is_visible_in_simcard_profile')">
      {{ translate(type.is_visible_in_simcard_profile ? 'yes' : 'no') }}
    </td>
    <td :data-label="translate('sim_task_list.task_types.is_default')">
      {{ translate(type.is_default ? 'yes' : 'no') }}
    </td>
  </tr>
</template>
<script>

export default {
  name: 'SimTaskListItem',
  components: {
  },
  props: ["type"],
  data () {
    return {
    }
  },
  computed: {

  },
  activated () {

  },
  mounted () {

  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.type{
  color: #252422;
  &:hover tr{
    background-color: #eee;
  }
  td{
    overflow: hidden;
  }
  .level{
    display: inline-block;
    width: 20px;
    height: 100%;
  }
  .has_child{
    background-color: #eee;
    font-weight: bold;
  }
  .name{
    text-align: left;
  }
  .inn{
    text-align: left;
  }
}
</style>
